// extracted by mini-css-extract-plugin
export default {"fieldWrapper":"TagsFilter_fieldWrapper__N2onJ","searchIcon":"TagsFilter_searchIcon__rQrvY"};